var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 151.462 197.405"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M151.462 75.712 75.75 0 0 75.75v121.655h7V78.649L75.75 9.9l68.712 68.712v111.793h-28.144v-80.217H98.239a29.53 29.53 0 0 0-45.449 0H34.712v87.217h7v-80.217h14.566l1.049-1.436a22.524 22.524 0 0 1 36.375 0l1.049 1.436h14.567v80.217h42.144Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.514 119.36a17.95 17.95 0 0 0-13.5 6.012H51v61.276h7v-54.276h7.454l1.049-1.435a11.16 11.16 0 0 1 18.022 0l1.049 1.435h7.453v54.276h7v-61.276H89.018a17.95 17.95 0 0 0-13.504-6.012"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.73 144.777h22v7h-22zM68.13 160.477h15.101v7H68.13z"
})))));
export default SvgLogo;